/**
 * @generated SignedSource<<23c33dd028025ffc7b1667780994a07b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StartSignupStep_BrandFragment$data = {
  readonly brandColorHex: string;
  readonly icon: {
    readonly url: string | null;
  } | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "StartSignupStep_BrandFragment";
};
export type StartSignupStep_BrandFragment$key = {
  readonly " $data"?: StartSignupStep_BrandFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StartSignupStep_BrandFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StartSignupStep_BrandFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "File",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "brandColorHex",
      "storageKey": null
    }
  ],
  "type": "Brand",
  "abstractKey": null
};

(node as any).hash = "c6c42e1502c786c2742863246276e10d";

export default node;
